export { usePlatformStore } from './model/platform-store';
export type { PlatformParams } from './model/types';
